<template>
  <div>
    <el-container>已删除数据</el-container>
    <el-container class="SelectBlock">


      <el-col class="FirstBlock" :sapn="3" >
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
            <el-dropdown-item command="b">根据使用人姓名ID查询</el-dropdown-item>
            <el-dropdown-item command="c">根据资产固定编码查询</el-dropdown-item>
            <el-dropdown-item command="d">根据类别查询</el-dropdown-item>
            <el-dropdown-item command="e">根据存放的区域查询</el-dropdown-item>
            <el-dropdown-item command="f">根据单位查询</el-dropdown-item>
            <el-dropdown-item command="g">根据资产状态查询</el-dropdown-item>
            <el-dropdown-item command="h">根据是否为帐外资产查询</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>


          <el-input v-if="selectCheck == 'a'" v-model.trim="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>

          <el-input v-if="selectCheck == 'b'" v-model.trim="SForm.SownerId" :value="ManagerUser"  placeholder="根据使用人姓名ID查询">
              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogManager = true">选择</el-button> </el-input>
                <el-dialog title="选择资产类别" :visible.sync="dialogManager" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="MangerData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreeMangerClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogManager = false">取 消</el-button>
                    <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                  </div>
                </el-dialog>


          <el-input v-if="selectCheck == 'c'" v-model.trim="SForm.SpropertyCode" placeholder="根据资产固定编码查询"></el-input>

          <el-input v-if="selectCheck == 'e'" v-model.trim="SForm.SplaceId" :value="SForm.SplaceRealId"
          append-to-body
          style="width: 250px;"
          placeholder="根据存放的区域查询">
              <el-button
                size="mini"
                 style="margin-top: 5px;"
                 slot="suffix"
                 type="text"
                @click="dialogPlace = true">选择</el-button></el-input>
                <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="PlaceData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePlaceClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>

                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPlace = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                  </div>
                </el-dialog>


          <el-input v-if="selectCheck == 'd'"  v-model.trim="SForm.SpropertyTypeId" placeholder="根据类别查询"></el-input>


          <el-select v-if="selectCheck == 'f'" v-model.trim="SForm.SunitId" placeholder="根据单位查询">
           <el-option
           v-for="i in DUnit"
           :label="i.unitName"
           :key="i.unitId"
           :value="i.unitId">
           </el-option>

           <el-select v-if="selectCheck == 'h'" v-model.trim="SForm.SoutProperty" placeholder="根据是否为帐外资产查询">
             <el-option label="是" value="1"></el-option>
             <el-option label="否" value="2"></el-option>
           </el-select>
          </el-select>


          <el-select v-if="selectCheck == 'g'" v-model.trim="SForm.SpropertyState" placeholder="是否为资产状态">
            <el-option label="在用" value='1'></el-option>
            <el-option label="待修" value='2'></el-option>
            <el-option label="在修" value='3'></el-option>
            <el-option label="备用" value='4'></el-option>
            <el-option label="闲置" value='5'></el-option>
            <el-option label="调剂" value='6'></el-option>
            <el-option label="待报废" value='7'></el-option>

            <el-option label="报废" value='8'></el-option>
            <el-option label="待确定" value='9'></el-option>
            <el-option label="在库" value='10'></el-option>

          </el-select>






        <el-button type="primary" @click="select(1)">查询</el-button>
        <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
      </el-col>
    </el-container>


    <el-container>

      <el-table
         :data="tableData"
         border
          @selection-change="handleSelectionChange"
         style="width: 98%;margin-top: 2%; margin-left: 1%;">


         <el-table-column
               type="selection"
               width="55">
             </el-table-column>

         <el-table-column
           label="资产固定编码"
           prop="propertyCode">
         </el-table-column>
         <el-table-column
           label="资产名称"
           prop="propertyName">
         </el-table-column>
         <el-table-column
           label="资产状态"
           prop="propertyState"
           >
           <template slot-scope="scope">
             <el-tag
             :type="scope.row.propertyState == 1?''
             :(scope.row.propertyState==2?'success'
             :(scope.row.propertyState==3?'info'
             :(scope.row.propertyState==4?'danger'
             :(scope.row.properyState==5?''
             :(scope.row.properyState == 6?'success'
             :(scope.row.properyState==7?'info'
             :(scope.row.properyState==8?''
             :(scope.row.properyState==9?'warning'
             :(scope.row.properyState==10?'danger':'warning')))))))))"
             effect="dark">
               <div v-if="scope.row.propertyState == 1">在用</div>
               <div v-if="scope.row.propertyState == 2">待修</div>
               <div v-if="scope.row.propertyState == 3">在修</div>
               <div v-if="scope.row.propertyState == 4">备用</div>
               <div v-if="scope.row.propertyState == 5">闲置</div>
               <div v-if="scope.row.propertyState == 6">调剂</div>
               <div v-if="scope.row.propertyState == 7">待报废</div>
               <div v-if="scope.row.propertyState == 8">报废</div>
               <div v-if="scope.row.propertyState == 9">待确定</div>
               <div v-if="scope.row.propertyState == 10">在库</div>

             </el-tag>
           </template>
         </el-table-column>
         <el-table-column
           label="资产使用人"
           prop="usedName">
         </el-table-column>

         <el-table-column
           label="资产创建时间"
           prop="createDate">
         </el-table-column>
         <el-table-column
           label="资产修改时间"
           prop="updateDate">
         </el-table-column>

         <el-table-column label="操作">
             <template slot-scope="scope">
                   <el-button type="text" @click="table = true">详情</el-button>


                   <el-drawer
                     title="资产详情!"
                     :visible.sync="table"
                     direction="rtl"
                     size="50%">


                     <el-descriptions border :column="2" style="width: 95%;margin-left: 2%;">
                         <el-descriptions-item label="资产主键ID">{{scope.row.propertyId}}</el-descriptions-item>
                         <el-descriptions-item label="单位">{{scope.row.unitName}}</el-descriptions-item>
                         <el-descriptions-item label="资产RFID">{{scope.row.propertyRfid}}</el-descriptions-item>
                         <el-descriptions-item label="规格">{{scope.row.propertySpecification}}</el-descriptions-item>

                         <el-descriptions-item label="资产类别Id">{{scope.row.propertyTypeId}}</el-descriptions-item>
                         <el-descriptions-item label="存放区域ID">{{scope.row.placeId}}</el-descriptions-item>

                         <el-descriptions-item label="存放地点">{{scope.row.holdPlace}}</el-descriptions-item>

                         <el-descriptions-item label="管理员部门名称">{{scope.row.managerDeptName}}</el-descriptions-item>

                         <el-descriptions-item label="管理员名称">{{scope.row.managerName}}</el-descriptions-item>
                         <el-descriptions-item label="帐外资产">
                                 <template slot-scope="scope">
                                    <div v-if="scope.row.outProperty == 1">是</div>
                                    <div v-if="scope.row.outProperty == 2">否</div>
                                 </template></el-descriptions-item>

                         <el-descriptions-item label="供应商">{{scope.row.supplier}}</el-descriptions-item>
                         <el-descriptions-item label="资产EPC">{{scope.row.epc}}</el-descriptions-item>
                     </el-descriptions>



                   </el-drawer>



               </template>
             </el-table-column>
          </el-table>

    </el-container>
    <div class="block">
             <el-pagination
               @size-change="select"
               @current-change="select"
               :current-page.sync="currentPage"
               :page-size="10"
               layout="prev, pager, next, jumper"
               :total="pageSize">
             </el-pagination>
           </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Property_Back',
     data () {
       const PlaceData = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];
       return {
         table:false,
         
         

         dialog: false,
         
         dialogOut:false,
         dialogManager:false,
         currentPage: 1,
         pageSize:1,
         dialogOutPlace:false,
         PlaceId:'',
         dialogFormEdit:false,
         
         
         MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
         table:false,
         DName:[{
           departmentId:'',
           departmentName:'',
         }],
         DUnit:[{
           unitName:'',
           unitId:'',
         }],
         defaultProps: {
                  children: 'children',
                  label: 'label'
                },
         SForm:{
           SpropertyName:'',
           SpropertyCode:'',
           SpropertyTypeId:'',
           SplaceId:'',
           SownerId:'',
           SunitId:'',
           SpropertyState:'',
           SoutProperty:'',
           SplaceRealId:"",
         },
           tableData: [{
                    createDate:'',
                    epc:'',
                    supplier:'',
                     del:'',
                     holdPlace:'',
                     managerDeptId:'',
                     managerDeptName:'',
                     managerId:'',
                     managerName:'',
                     mgrName:'',
                     outProperty:'',
                     ownerDeptId:'',
                     ownerId:'',
                     placeId:'',
                     propertyCode:'',
                     propertyId:'',
                     propertyModel:'',
                     propertyName:'',
                     propertyRfid:'',
                     propertySpecification:'',
                     propertyState:'',
                     propertyType:'',
                     propertyTypeId:'',
                     unitId:'',
                     unitName:'',
                     usedDeptName:'',
                     updateDate:'',
                     usedName:'',
                  }],
                  multipleSelection: [],
                  selectCheck:'',
        };
     },
    mounted:function() {
	// 首先是当页面加载的时候自动渲染这些数据
	
	// 表格里面的数据
      this.showData();
	  // 查询条件里面的数据预加载    部门信息
      this.showDepartmentData();
	  // 查询条件里面的数据预加载    单位信息
      this.showUnitData();
	  // 查询条件里面的数据预加载    人员信息
      this.showMData();
	  // 查询条件里面的数据预加载    单位信息
      this.showPlaceData();
    },
    watch: {
		// 树状结构的显示核心
          filterText(val) {
            this.$refs.tree.filter(val);
          }
        },
     methods: {
		 // 下拉菜单存放点击时选中的数据
       handleCommand(command) {
              this.selectCheck = command
             },
			 
			 // 查询方法，基本所有查询方法都是SForm里的数据
			 // SForm数据在325行el-dropdown里面就是SForm数据的展现方式
			 // val是分页查询是所需要给出的数据
       select(val){
          var authorization = Cookies.get("Authorization");
          var paramsData = {
            currentPage: val || 1 ,
            del:2,
            pageSize: 10,
            propertyName:this.SForm.SpropertyName || undefined,
            propertyCode:this.SForm.SpropertyCode || undefined,
            propertyTypeId:this.SForm.SpropertyTypeId || undefined,
            placeId:this.SForm.SplaceRealId || undefined,
            ownerId:this.ManagerUser || undefined,
            unitId:this.SForm.SunitId || undefined,
            propertyState:this.SForm.SpropertyState || undefined,
            outProperty:this.SForm.SoutProperty || undefined,
          }

           this.axios({
               method: 'GET',
               url: '/property/showPropertyMsg',
               params:paramsData,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{

                this.tableData=resp.data.data;

                this.pageSize = resp.data.count;
             })
       },
	   // 重置，刷新所有数据
       resetForm(formName) {
         Object.assign(this.$data.SForm, this.$options.data().SForm)
         this.select()
           },
	   // 请求小杜接口public/getTree获取区域信息然后将数据传给PlaceData在71行
       showPlaceData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 5,
        }
         this.axios({
             method: 'GET',
             url: '/public/getTree',

             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{

            this.PlaceData=resp.data.data;
           })
       },
	   // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
        TreePlaceClick(data){
            this.SForm.SplaceRealId = data.id
            this.SForm.SplaceId = data.label

        },
		// 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID
        TreeMangerClick(data){
            this.ManagerUser = data.realId
            this.SForm.SownerId = data.label
        },
		// 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
        TreeOutPlaceClick(data){
            this.OutPlaceId = data.label
        },
		
        filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
              },
			  
		// 请求小杜接口/public/getUnitTree获取人员信息然后将数据传给MangerData和UserData在37行
        showMData(){
         var authorization = Cookies.get("Authorization");
          this.axios({
              method: 'GET',
              url: '/public/getUnitTree',
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{

             // var arr = new Array(resp.data.data) ;
             this.MangerData=resp.data.data;
             this.UserData = resp.data.data;
            })
        },


		// 请求小杜接口/public/getCanHandleDepartmentList获取部门信息然后将数据传给DName
        showDepartmentData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getCanHandleDepartmentList',
              params:params,
              header:{
               'Authorization':authorization,
               'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.DName = resp.data.data;

            })
        },





		// 请求小杜接口/public/getCanWatchUnit获取单位信息然后将数据传给DUnit在96行
        showUnitData(){
         var authorization = Cookies.get("Authorization");
         var params = {
           currentPage: 1,
           pageSize: 5,
         }
          this.axios({
              method: 'GET',
              url: '/public/getCanWatchUnit',
              params:params,
              header:{
               'Authorization':authorization,
              	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
              	}
            }).then((resp)=>{
             this.DUnit = resp.data.data;
            })
        },



		// 主要数据展示给tableData
        showData(){
          var authorization = Cookies.get("Authorization");
          var params = {
            currentPage: 1,
            pageSize: 10,
            del:2
          }
           this.axios({
               method: 'GET',
               url: '/property/showPropertyMsg',
               params:params,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{

              this.tableData = resp.data.data;
              this.pageSize = resp.data.count;

             })
            },
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Back.vue